import { toast } from "react-toastify";
import { getTokenFromLocal, handleResponse } from "../../_helpers/handleResponseMiddleware";

let centralBaseUrl = process.env.REACT_APP_CENTRAL_BASE_URL;
let centralJavaUrl = process.env.REACT_APP_BASE_URL_COMMON;
let centralNodeUrl = process.env.REACT_APP_CENTRAL_EQUIPMENT_URL;
let centralCommonUrl = process.env.REACT_APP_COMMON_BASE_URL;

export async function getPaymentHistoryService(params) {
  
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;
  const paramsData =  {
    ...params,
  }

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...paramsData }),
  };

  return fetch(
    `${centralBaseUrl}/getPaymentHistory`,
    requestOptions
  )
    .then(handleResponse)
    .then(res => res)
    .catch(function (error) {
      console.error(error);
      toast.error(error.message)
    })
    .then(function (response) {
      // always executed
      return response ;
    });
}

export function getSurgeryCallDetailsService(appId) {
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return fetch(
      `${centralJavaUrl}/api/surgery-status/${appId}`,
      requestOptions
    )
      .then(handleResponse)
      .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
}

export async function getMobileHashingService(params) {
  
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;
  const paramsData =  {
    ...params,
  }

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...paramsData }),
  };

  return fetch(
    `${centralCommonUrl}/des/hash-mobile`,
    requestOptions
  )
    .then(handleResponse)
    .then(res => res)
    .catch(function (error) {
      console.error(error);
      toast.error(error.message)
    })
    .then(function (response) {
      // always executed
      return response ;
    });
}

export async function getLinkForwardingService(params) {
  
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;
  const paramsData =  {
    ...params,
  }

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...paramsData }),
  };

  return fetch(
    `${centralNodeUrl}/bd-dashboard/forwarding`,
    requestOptions
  )
    .then(handleResponse)
    .then(res => res)
    .catch(function (error) {
      console.error(error);
      toast.error(error.message)
    })
    .then(function (response) {
      // always executed
      return response ;
    });
}


